export const FETCH_LOAD_USER_BY_USER_ID_REQUEST = 'FETCH_LOAD_USER_BY_USER_ID_REQUEST'
export const FETCH_LOAD_USER_BY_USER_ID_SUCCESS = 'FETCH_LOAD_USER_BY_USER_ID_SUCCESS'
export const FETCH_LOAD_USER_BY_USER_ID_FALUIRE = 'FETCH_LOAD_USER_BY_USER_ID_FALUIRE'
export const FETCH_CLEAR_USER_BY_USER_ID = 'FETCH_CLEAR_USER_BY_USER_ID'
